<template>
  <v-card class="mx-auto br-3">
    <v-card-title class="pb-0">
      <v-icon
        large
        left
      >
        mdi-water
      </v-icon>
      <span class="subtitle-1">{{ $t('CW') }}</span>
    </v-card-title>

    <v-card-text class="pb-0">
      <div class="d-flex flex-row align-center">
        <div class="w-mode text-center">
          <v-btn
            @click="cwModeSheet = (permission == 0 || permission == 1) ? !cwModeSheet : cwModeSheet"
            :color="(cwMode != 0) ? 'primary' : ''"
            rounded
            large
            :loading="savingCwMode"
            :disabled="savingCwMode"
          >
            <v-icon>
              {{ cwModes[cwMode].ico }}
            </v-icon>
          </v-btn>
        </div>
        <div class="d-flex flex-column w-set pa-0 text-center font-weight-medium subtitle-1">
          <div class="accent--text">{{ parseInt(this.params.cwTempSet) }} &deg;C</div>
          <div class="secondary--text" v-if="this.params.cwTempReduced">{{ parseInt(this.params.cwTempReduced) }} &deg;C</div>
        </div>
        <v-card flat :to="(permission == 0 || permission == 1) ? '/dashboard/cw-temp/'+controllerId : '/dashboard/'+controllerId" class="w-read">
          <v-gauge :value="cwTemp" :minValue="cwTempMin" :maxValue="cwTempMax" :decimalPlace="0" :options="gOptions" height="250" />
          <div class="unit">&deg;C</div>
        </v-card>
      </div>
    </v-card-text>

    <v-card-actions class="pt-0">
      <v-btn v-if="cwCalendar !== undefined"
      icon large 
      :color="(cwCalendar == 1) ? 'primary' : 'info'" 
      :loading="savingCwCalendar"
      :disabled="savingCwCalendar"
      @click="calendarSheet = (permission == 0 || permission == 1) ? !calendarSheet : calendarSheet" class="key-btn">
        <v-icon>mdi-calendar-month</v-icon>
      </v-btn>
      <v-btn v-if="pumpCW !== undefined"
      icon large 
      :color="(pumpCW == 1) ? 'primary' : 'info'" 
      @click="pumpCwSheet = (permission == 0 || permission == 1) ? !pumpCwSheet : pumpCwSheet" class="key-btn">
        <v-icon>mdi-atom-variant</v-icon>
      </v-btn>
      <v-spacer></v-spacer>
    </v-card-actions>

    <v-bottom-sheet v-model="calendarSheet">
      <v-sheet>
        <div class="px-4 pt-6 pb-3">
          <v-toolbar flat>
            <v-toolbar-title class="subtitle-1">{{ $t('tryb-kal') }}</v-toolbar-title>
            <div class="flex-grow-1"></div>
            <v-btn icon @click="calendarSheet = !calendarSheet">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-list flat>
            <v-list-item ripple class="br-3 selected">
              <v-list-item-icon>
                <v-icon>mdi-calendar-month</v-icon>
              </v-list-item-icon>
              <v-list-item-content  @click="onChangeCwCalendar">
                <v-list-item-title class="title">{{ $t('wlacz') }}</v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>
                <v-switch :input-value="cwCalendarSetting" @change="onChangeCwCalendar" color="primary"></v-switch>
              </v-list-item-action>
            </v-list-item>
            <v-list-item :to="'/dashboard/cw-calendar/'+controllerId" class="br-3">
              <v-list-item-icon>
                <v-icon>mdi-settings</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title class="title">{{ $t('Ustawienia') }}</v-list-item-title>
              </v-list-item-content>
              <v-list-item-icon>
                <v-icon>mdi-chevron-right</v-icon>
              </v-list-item-icon>
            </v-list-item>
          </v-list>
        </div>
      </v-sheet>
    </v-bottom-sheet>

    <v-bottom-sheet v-model="pumpCwSheet">
      <v-sheet>
        <div class="px-3 py-6">
          <v-toolbar flat>
            <v-toolbar-title class="subtitle-1">{{ $t('Pompa CW') }} {{ (this.params.pumpCW == '1') ? $t('dziala') : $t('nie dziala') }}</v-toolbar-title>
            <div class="flex-grow-1"></div>
            <v-btn icon @click="pumpCwSheet = !pumpCwSheet">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
        </div>
      </v-sheet>
    </v-bottom-sheet>

    <v-bottom-sheet v-model="cwModeSheet">
      <v-sheet>
        <div class="px-4 pt-6">
          <v-toolbar flat>
            <v-toolbar-title class="subtitle-1">{{ $t('tryb-cw') }}</v-toolbar-title>
            <div class="flex-grow-1"></div>
            <v-btn icon @click="cwModeSheet = !cwModeSheet">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-list one-line class="transparent">
            <v-radio-group :mandatory="true" v-model="cwModeSetting">
                <template v-for="(item, index) in cwModes">
                  <v-list-item :key="index" @click="setCwMode(index)" class="br-3" :class="{selected: cwModeSetting == index}">
                      <v-list-item-icon class="text-uppercase">
                      <v-icon>{{ item.ico }}</v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title class="title">{{ $t(item.name) }}</v-list-item-title>
                      </v-list-item-content>
                      <v-list-item-action>
                        <v-radio :value="index" :key="index" color="primary" class="mr-0"></v-radio>
                      </v-list-item-action>
                  </v-list-item>
                </template>
            </v-radio-group>
          </v-list>
        </div>
      </v-sheet>
    </v-bottom-sheet>
  </v-card>
</template>

<script>
import VGauge from "vgauge";
export default {
  components: {
    VGauge
  },
  data: () => ({
    cwModes: [
      { name: 'wylaczony', ico: 'mdi-cancel' },
      { name: 'rown-co', ico: 'mdi-shuffle-disabled' },
      { name: 'prio-cw', ico: 'mdi-water' },
      { name: 'lato', ico: 'mdi-white-balance-sunny' },
      { name: 'cw+och', ico: 'mdi-water-outline' }
    ],
    cwModeSetting: null,
    cwModeSheet: false,
    savingCwMode: false,
    pumpCwSheet: false,

    more: false,
    value: 35,
    calendarSheet: false,
    cwCalendarSetting: false,
    savingCwCalendar: false
  }),
  computed: {
    params () {
      return this.$store.state[this.moduleName].params
    },
    cwMode () {
      return parseInt(this.params.cwMode)
    },
    cwTemp () {
      return parseInt(this.params.cwTemp)
    },
    cwTempReduced () {
      return parseInt(this.params.cwTempReduced)
    },
    cwCalendar () {
      return (this.params.cwCalendar !== undefined) ? parseInt(this.params.cwCalendar) : undefined
    },
    pumpCW () {
      return (this.params.pumpCW !== undefined) ? parseInt(this.params.pumpCW) : undefined
    },
    cwTempMin() {
      return this.$store.state[this.moduleName].cwTempMin
    },
    cwTempMax() {
      return this.$store.state[this.moduleName].cwTempMax
    },
    dark() {
      return this.$store.state.user.dark;
    },
    gOptions() {
      return {
        angle: -0.18,
        lineWidth: 0.18,
        pointer: {
          length: 0,
          strokeWidth: 0
        },
        colorStart: (this.dark) ? '#EF5350' : '#EF3024',
        strokeColor: (this.dark) ? 'rgba(0,0,0,0.3)' : '#E0E0E0'
      }
    }
  },
  created () {
    if (this.cwModeRetProt != 1) {
      this.cwModes.pop();
    }
    this.cwModeSetting = this.cwMode;
    this.cwCalendarSetting = (this.cwCalendar == 1) ? true : false;
  },
  props: ['moduleName','controllerId','permission','loading'],
  methods: {
    setCwMode(mode) {
      this.savingCwMode = true;
      this.cwModeSetting = mode;
      this.cwModeSheet = false;

      this.$store.dispatch(`${this.moduleName}/setCwMode`, mode)
      .then(res => {
        this.savingCwMode = false;
        if (res.error) {
          this.$store.commit("alert", {
            color: "error",
            text: res.error.code
          });
          this.cwModeSetting = this.cwMode;
        } 
      });
    },
    onChangeCwCalendar() {
      this.cwCalendarSetting = !this.cwCalendarSetting;
      this.setCwCalendar((this.cwCalendarSetting) ? 1 : 0);
    },
    setCwCalendar(mode) {
      console.log('setCwCalendar: ' + mode);
      this.savingCwCalendar = true;
      setTimeout(() => { this.calendarSheet = false; }, 300);
      this.$store.dispatch(`${this.moduleName}/setCwCalendar`, mode)
      .then(res => {
        this.savingCwCalendar = false;
        if (res.error) {
          this.$store.commit("alert", {
            color: "error",
            text: res.error.code
          });
          this.cwCalendarSetting = (this.cwCalendar == 1) ? true : false;
        }
      });
    },
    gotoDash (id) {
      this.$router.push({ path: '/dashboard/'+id });
    }
  }
  
}
</script>

<style>
</style>